import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_maintenance_history = () => {
  useAuthRedirect();
  const { id, branch } = useParams(); 
  const [vehicleResult, setVehicle] = useState([]);
  const storedBranch = localStorage.getItem("branch");
  const [selectedBranch, setSelectedBranch] = useState(storedBranch || ""); 
  const navigate = useNavigate();
  const [header, setHeader] = useState({});
  const canView  = hasPermission("Vehicle Log Book", "view");
  const [cum, setCum] = useState({});

  // Fetch vehicle details report when the component mounts
  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_report_api/${id}`)
      .then((response) => {
        setVehicle(response.data.vehicles);
      })
      .catch((error) => {
        console.error("Error fetching vehicle details:", error);
      });
  }, [id]);

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_reportheader_api?vcode=${id}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                vehicle_type: items[0].vehicle_type || "N/A",
                vehicle_name: items[0].vehicle_name || "N/A",
                vehicle_code: items[0].vehicle_code || "N/A",
                vehicle_number: items[0].vehicle_number || "N/A",
            };

            setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [id, branch]); 




  useEffect(() => {
    const fetchCumTot = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/log_book_get_main_own?vcode=${id}`);
        if (response.data && response.data.cumulativeHrs?.length > 0) {
            const items = response.data.cumulativeHrs;

            const storeReqHeader = {
                total_hours: items[0].total_hours || "N/A",
                total_km: items[0].total_km || "N/A",
                vBasis: items[0].vehicle_basis || "N/A",
            };

            setCum(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchCumTot();
  }, [id]); 

  // near top of the component
const [site, setSite] = useState({
  ok: true,
  name: "Infraconsoft",
  logo: null,
  address: "",
  email: "",
  phone: "",
  _ts: 0,
});

useEffect(() => {
  let ignore = false;
  (async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/siteinfo");
      const s = res?.data || {};
      let logo = s.logo || null;
      if (logo && !/^https?:\/\//i.test(logo)) {
        if (!logo.startsWith("/")) logo = `/${logo}`;
        logo = `${window.location.origin}${logo}`;
      }
      if (!ignore) {
        setSite({
          ok: !!s.ok,
          name: s.name || "Infraconsoft",
          logo,
          address: s.address || "",
          email: s.email || "",
          phone: s.phone || "",
          _ts: Date.now(),
        });
      }
    } catch (e) {
      console.error("Failed to load /siteinfo", e);
    }
  })();
  return () => { ignore = true; };
}, []);


  const exportToExcel = () => {
  // ---- your original row mapping (unchanged math) ----
  const exportData = vehicleResult.map((item, index) => {
    const changing_hrs = item.changing_hrs ? parseFloat(item.changing_hrs) : 0;
    const last_modified_hr = item.last_modified_hr ? parseFloat(item.last_modified_hr) : 0;
    const tot = changing_hrs + last_modified_hr;
    const now_hr = tot - (cum?.total_hours ?? 0);
    const now_km = tot - (cum?.total_km ?? 0);

    return {
      "S.No": index + 1,
      "Description": item.fld_Descriptions,
      "Oil Grade": item.oilgrade,
      "Last Changed Hr/Km": item.last_modified_hr,
      "Service Hr/Km": item.changing_hrs,
      "Next Service Cumulative Hr/Km": tot.toFixed(2),
      "Current Cum Hr/Km": cum?.vBasis === "Hour" ? (cum?.total_hours ?? 0) : (cum?.total_km ?? 0),
      "Remaining Hr/Km": (cum?.vBasis === "Hour" ? now_hr : now_km).toFixed(2),
    };
  });

  // Preserve your column order
  const headers = exportData.length ? Object.keys(exportData[0]) : [
    "S.No","Description","Oil Grade","Last Changed Hr/Km","Service Hr/Km",
    "Next Service Cumulative Hr/Km","Current Cum Hr/Km","Remaining Hr/Km"
  ];
  const dataRows = exportData.map(r => headers.map(h => r[h] ?? ""));

  // ---- minimal company header + title ----
  const COLS = headers.length;
  const fullWidth = (text="") => [text, ...Array(COLS - 1).fill("")];
  const title = `Vehicle Maintenance Log${cum?.vBasis ? ` — ${cum.vBasis}` : ""}`;

  const aoa = [
    fullWidth((site.name || "Infraconsoft").toUpperCase()),
    fullWidth(site.address || ""),
    fullWidth([site.phone ? `Ph: ${site.phone}` : "", site.email ? `Email: ${site.email}` : ""].filter(Boolean).join(" | ")),
    [], // spacer
    fullWidth(title),
    [], // spacer
    headers,
    ...dataRows,
  ];

  // Build worksheet from AOA so we can merge the header rows
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);

  // Merges for the header lines
  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLS - 1 } }, // name
    { s: { r: 1, c: 0 }, e: { r: 1, c: COLS - 1 } }, // address
    { s: { r: 2, c: 0 }, e: { r: 2, c: COLS - 1 } }, // phone/email
    { s: { r: 4, c: 0 }, e: { r: 4, c: COLS - 1 } }, // title
  ];

  // Column widths (tweak as you like)
  const widthMap = {
    "S.No": 6,
    "Description": 36,
    "Oil Grade": 16,
    "Last Changed Hr/Km": 22,
    "Service Hr/Km": 18,
    "Next Service Cumulative Hr/Km": 30,
    "Current Cum Hr/Km": 22,
    "Remaining Hr/Km": 20,
  };
  worksheet["!cols"] = headers.map(h => ({ wch: widthMap[h] || 18 }));

  // Freeze after header block
  worksheet["!freeze"] = { xSplit: 0, ySplit: 6, topLeftCell: "A7", activePane: "bottomLeft" };

  // Workbook + download
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Own Vehicle Log Book");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
  saveAs(blob, `vehmain_log_book.xlsx`);
};

  
  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
            <div className="back-div">
            <h2 className="add-txt">Vehicle Maintenance - Details</h2>
            <Link to={`/vehicle_logbook_list`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
            </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="add-new-container">
  <button className="add-new-btn" onClick={exportToExcel}>
    <i className="fa-solid fa-file-excel"></i> Export to Excel
  </button>
</div><br></br>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vehicle_code" value={header.vehicle_code} readOnly/>

              </div>
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="vehicle_type" value={header.vehicle_type} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vehicle_name" value={header.vehicle_name} readOnly />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehicle_number" value={header.vehicle_number} readOnly />
              </div>
            </div>           
            
            <div className="content-table">
            <table>
  <thead>
    <tr>
      <th>S.No</th>
      <th>Description</th>
      <th>Oil Grade</th>
      <th>Last Changed Hr/Km</th>
      <th>Service Hr/Km</th>
      <th>Next service cumulative Hr/Km</th>
      <th>Current Cum Hr/Km</th>
      <th>Remaining Hr</th>
    </tr>
  </thead>
  <tbody>
    {vehicleResult.length > 0 ? (
      vehicleResult.map((item, index) => {
     
        const changing_hrs = item.changing_hrs ? parseFloat(item.changing_hrs) : 0;
        const last_modified_hr = item.last_modified_hr ? parseFloat(item.last_modified_hr) : 0;
        const tot = changing_hrs + last_modified_hr;
        const now_hr = tot - cum.total_hours;
        const now_km = tot - cum.total_km;

       
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.fld_Descriptions}</td>
            <td>{item.oilgrade}</td>
            <td>{item.last_modified_hr}</td>
            <td>{item.changing_hrs}</td>
            <td>{tot.toFixed(2)}</td>
            {cum.vBasis === "Hour" && <td>{cum.total_hours}</td>}
            {cum.vBasis === "Km" && <td>{cum.total_km}</td>}
            {cum.vBasis === "Hour" && <td>{now_hr.toFixed(2)}</td>}
            {cum.vBasis === "Km" && <td>{now_km.toFixed(2)}</td>}
           
          </tr>
        );
      })
    ) : (
      <tr>
        <td colSpan="10">No Data Available</td>
      </tr>
    )}
  </tbody>
</table>
            </div>
          </form>
        </div>

      
      </div>
    </div>
  );
};

export default Vehicle_maintenance_history;
